export default {
  install(Vue, {store}) {

    Vue.prototype.$withPolicy = function (appName, ...services) {
      if (store.getters.getUser.role === 'owner')
        return true

      appName = Vue.parse.toSnakecase(appName)
      services = services.map(service => Vue.parse.toSnakecase(service))
      const policies = store.getters.getPolicies
      return policies && policies.some(police => police.active && police.appName === appName && services.includes(police.name))
    }

    // Igual ao $withPolicy, mas SEM passar as chaves por toSnakecase.
    //
    // O catálogo da #80506 usa o nome exato do service, e o toSnakecase quebra
    // os que têm camelCase no meio: `customField/insert_or_update` viraria
    // `custom_field/insert_or_update` e nunca casaria. Use este nas chaves
    // novas; o $withPolicy fica para as chamadas antigas.
    Vue.prototype.$can = function (appName, ...services) {
      if (store.getters.getUser.role === 'owner')
        return true

      const policies = store.getters.getPolicies
      return !!policies && policies.some(police =>
        police.active && police.appName === appName && services.includes(police.name))
    }

    // Ponto de checagem NOVO da #80506.
    //
    // Numa conta que ainda não virou para grupos, a permissão não existe e
    // ninguém tem policy dela — esconder a tela ali seria tirar acesso que a
    // pessoa tem hoje. Espelha o `new_service_enabled?` do backend. Quando a
    // última conta migrar, vira alias de $can.
    Vue.prototype.$canNew = function (appName, ...services) {
      if (!store.getters.usesPermissionGroups)
        return true

      return Vue.prototype.$can.call(this, appName, ...services)
    }

    // Conta em grupos não tem `download_docs`: cada documento tem a sua chave
    // (`download_boleto`, `download_fici`...). Conta legada segue no `download_docs`.
    Vue.prototype.$canDownload = function (appName, ...services) {
      if (!store.getters.usesPermissionGroups)
        return Vue.prototype.$withPolicy.call(this, appName, 'download_docs')

      return Vue.prototype.$can.call(this, appName, ...services)
    }

    // Tipo fora do mapa (ex.: `warning`) não tem permissão própria: basta qualquer permissão de documento.
    Vue.prototype.$canDownloadKind = function (appName, kind) {
      const service = documentPermission(appName, kind)
      if (!service)
        return Vue.prototype.$canDownload.call(this, appName, ...documentPermissions(appName))

      return Vue.prototype.$canDownload.call(this, appName, service)
    }
  }
}

// Espelho do PermissionCatalog::DOCUMENT_PERMISSIONS do backend.
export const DOCUMENT_PERMISSIONS = {
  'cm-frotas': {
    boleto: 'download_boleto',
    fici: 'download_fici',
    demonstrativo: 'download_demonstrativo',
    notification: 'download_notification',
    ait: 'download_notification'
  },
  'cm-embarcador': {
    boleto: 'download_boleto',
    fici: 'download_fici',
    demonstrativo: 'download_demonstrativo',
    vistas: 'download_process_views',
    notificacao: 'download_notification',
    NA: 'download_notification',
    NP: 'download_notification',
    autuacao: 'download_notification'
  }
}

export function documentPermission(appName, kind) {
  return (DOCUMENT_PERMISSIONS[appName] || {})[kind]
}

export function documentPermissions(appName) {
  return [...new Set(Object.values(DOCUMENT_PERMISSIONS[appName] || {}))]
}
